import { useMutation } from 'react-query';
import {
  createSportUnityAsync,
  deleteSportUnityAsync,
  getSportUnitiesByLicenseAsync,
  getSportUnitiesByLicenseCountAsync,
  getSportUnityAsync,
  updateSportUnityAsync,
} from '../../index';

export const useCreateSportUnity = () => useMutation(createSportUnityAsync);

export const useUpdateSportUnity = () => useMutation(updateSportUnityAsync);

export const useDeleteSportUnity = () => useMutation(deleteSportUnityAsync);

export const useGetSportUnity = () => useMutation(getSportUnityAsync);

export const useGetAllSportUnitiesByLicenseAsync = () =>
  useMutation(getSportUnitiesByLicenseAsync);

export const useGetAllSportUnitiesByLicenseCountAsync = () =>
  useMutation(getSportUnitiesByLicenseCountAsync);
